import * as React from 'react';
import * as styles from './BetLeadersList.css';
import { InlineText2, InlineText3 } from '@cian/ui-kit/typography';
import { IFormattedBetLeader } from '../../../../redux/reducers';
import { Image } from '@cian/ui-kit/image';
import { LeaderWrapper } from './components/LeaderWrapper';

interface IBetLeadersListProps {
  leaders: IFormattedBetLeader[];
}

export const BetLeadersList = ({ leaders }: IBetLeadersListProps) => {
  return (
    <>
      {leaders.length === 0 && <InlineText2>Пока ещё никто не поставил... Будьте первым.</InlineText2>}

      {leaders.map(({ bet, auctionPlace, companies, otherCompanies }) => (
        <LeaderWrapper key={auctionPlace}>
          <InlineText2>{auctionPlace}.</InlineText2>

          <span className={styles['bet-wrapper']}>
            <InlineText2>{bet}</InlineText2>
          </span>

          <span className={styles['images']}>
            {companies.map(({ avatarUrl, name }, index) => (
              <span key={index} className={styles['image-wrapper']}>
                <Image width={16} height={16} src={avatarUrl} title={name} borderRadius="4px" />
              </span>
            ))}
          </span>

          {!!otherCompanies.length && (
            <span className={styles['more-wrapper']}>
              <InlineText3 color="black_60">ещё {otherCompanies.length}</InlineText3>
            </span>
          )}
        </LeaderWrapper>
      ))}
    </>
  );
};
